import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.less';
import AppRouterWithContexts from './AppRouter';
ReactDOM.render(React.createElement(AppRouterWithContexts, null), document.getElementById('root'));
//# sourceMappingURL=index.js.map